var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OtherPage"},[(_vm.view_type === 'detail')?[_c('OtherPageDetail',{on:{"catchTitle":_vm.setTitle}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }